"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderClaimStatus = void 0;
var OrderClaimStatus;
(function (OrderClaimStatus) {
    OrderClaimStatus[OrderClaimStatus["Claimed"] = 0] = "Claimed";
    OrderClaimStatus[OrderClaimStatus["Cancelled"] = 1] = "Cancelled";
})(OrderClaimStatus || (exports.OrderClaimStatus = OrderClaimStatus = {}));
//# sourceMappingURL=order-claim-status.enum.js.map